// Kai's own Verify email card: Kai Support (first line or escalated stage) shows it when a tool needs
// the customer's account data. It is a BOT comment with a `verifyemail` action and, unlike the
// workflow's "Verify email" step, no `workflowStep`. BotActionInput shows an action only while it is
// the conversation's last message and only in a workflow conversation, but Kai often writes right
// after the card (its answer to a message the card crossed, the answer step's "ask another question"
// line), and Kai Support also works conversations no workflow runs in (a bug report): the card
// vanished and the customer was asked to fill in a card they could not see.

type CommentLike = { id?: string; type?: string; createdAt?: string | Date; data?: any };

/** How long the request behind Kai's card takes a code (server KAI_VERIFY_REQUEST_TTL_SECONDS). */
const KAI_VERIFY_CARD_OPEN_MS = 30 * 60 * 1000;

/**
 * The Kai card the customer still has to answer: the newest one, while only Kai wrote after it. A
 * message from the customer (the receipt of the code included) or a teammate settles it, and so does
 * the request expiring.
 */
export const openKaiVerifyCard = <T extends CommentLike>(
  comments: T[] | null | undefined,
  now: number = Date.now(),
): T | undefined => {
  const list = comments ?? [];
  for (let index = list.length - 1; index >= 0; index--) {
    const comment = list[index];
    if (comment?.type !== "BOT") {
      return undefined;
    }
    if (comment.data?.action?.type !== "verifyemail") {
      continue;
    }
    if (comment.data?.workflowStep) {
      return undefined;
    }
    const shownAt = new Date(comment.createdAt ?? 0).getTime();
    return now - shownAt <= KAI_VERIFY_CARD_OPEN_MS ? comment : undefined;
  }
  return undefined;
};
